import { TerminalActivtyLogModel } from "../../app/data/terminal-summary/TerminalListModel";
import { LastIdsPaginationModel } from "../../app/data/common/models";
import { BaseState } from "..";

export default interface TerminalActivitylogState extends BaseState {
  loading: boolean;
  loadingFail: boolean;
  loadingFailed: boolean;
  loaded: boolean;
  requestStarted: boolean;
  fetchPortionStarted: boolean;
  requestCreator: string;
  requestSucceed: boolean;
  requestFailed: boolean;
  requestResponseCode: number;
  requestError: string;
  pickupsFetchedAll: boolean;
  terminalActivityLogs: TerminalActivtyLogModel[];
  terminalActivityLogsRequest: {
    page: number,
    last: boolean
  };
  loadedTerminalActivityLogPages: LastIdsPaginationModel[];
}

export const initialTerminalActivitylogState: TerminalActivitylogState = {
  loading: false,
  loadingFail: false,
  loadingFailed: false,
  loaded: false,
  requestStarted: false,
  fetchPortionStarted: false,
  requestCreator: "",
  requestSucceed: false,
  requestFailed: false,
  requestResponseCode: 0,
  requestError: "",
  pickupsFetchedAll: false,
  terminalActivityLogs: [],
  terminalActivityLogsRequest: {
    page: 0,
    last: false
  },
  loadedTerminalActivityLogPages: [],
};
